import { render, staticRenderFns } from "./chatRobot.vue?vue&type=template&id=a19ec870&scoped=true"
import script from "./chatRobot.vue?vue&type=script&lang=js"
export * from "./chatRobot.vue?vue&type=script&lang=js"
import style0 from "./chatRobot.vue?vue&type=style&index=0&id=a19ec870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19ec870",
  null
  
)

export default component.exports